import NotificationsPage from "src/routes/Notifications/components/NotificationsPage";

const Notifications = () => <NotificationsPage />;

export default Notifications;
